import { FC } from 'react';
import CopyTextButton from 'v3/common/components/CopyTextButton';
import PortalToTarget from 'v3/common/components/PortalToTarget';

const oneIndentation = ' ';

const Iifl: FC = () => (
  <div id="stepper__container">
    <PortalToTarget targetClassName="login-modal__header" allowForWeb>
      <h3>IIFL API Setup in 12 Steps</h3>
    </PortalToTarget>

    <div className="stepper">
      <li className="stepper_item" data-stepper="1">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            To start<span>click on this link</span> to Access the IIFL API Portal
          </h2>
          <button className="stepper-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 3H21V9"
                stroke="#1F252C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 14L21 3"
                stroke="#1F252C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11"
                stroke="#1F252C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <a href="https://ttblaze.iifl.com/dashboard#!/login" target="blank" rel="noreferrer">
              Open Dashboard{' '}
            </a>
          </button>
        </div>
      </li>
      <li className="stepper_item" data-stepper="2">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Click <span>Create an Account</span>
          </h2>
          <img src="/images/broker_setup_guide/iifl/IIFL-Step-1.png" className="w-100" alt="IIFL XTS login" />
        </div>
      </li>
      <li className="stepper_item" data-stepper="3">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Create profile by entering details. Field marked with * are mandatory
          </h2>
          <img
            src="/images/broker_setup_guide/iifl/IIFL-Step-2.png"
            className="w-100"
            alt="IIFL XTS signup"
          />
        </div>
      </li>
      <li className="stepper_item" data-stepper="4">
        <div className="stepper_content">
          <h2 className="stepper__heading">Verification mail will be send on your email id.</h2>
          <img src="/images/broker_setup_guide/iifl/IIFL-Step-3.png" alt="IIFL Email verification" />
        </div>
      </li>
      <li className="stepper_item" data-stepper="5">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Post successful email verification, You can login with credentials which shared over email.
          </h2>
          <img src="/images/broker_setup_guide/iifl/IIFL-Step-3.png" alt="IIFL Email verification" />
        </div>
      </li>
      <li className="stepper_item" data-stepper="6">
        <div className="stepper_content">
          <h2 className="stepper__heading"> After successful login, click CREATE NEW APPLICATION</h2>
          <img
            src="/images/broker_setup_guide/iifl/IIFL-Step-4.png"
            className="w-100"
            alt="IIFL Create new application"
          />
        </div>
      </li>
      <li className="stepper_item" data-stepper="7">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Click validate and Enter broker client id and api login password.
          </h2>
          <img src="/images/broker_setup_guide/iifl/IIFL-Step-5.png" className="w-100" alt="Broker " />
        </div>
      </li>
      <li className="stepper_item" data-stepper="8">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Go to API Catalogue and Click subscribe
            {oneIndentation}
            <span>Interactive Order API</span>
          </h2>
        </div>
      </li>
      <li className="stepper_item" data-stepper="9">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Fill below details in appropriate fields and click CREATE NEW APPLICATION.
          </h2>

          <div className="stepper__form">
            <div className="stepper__form-group">
              <h6>App Name:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="IIFLMARKET" disabled />
                </span>
                <CopyTextButton text="IIFLMARKET" />
              </div>
            </div>

            <div className="stepper__form-group">
              <h6>App Description:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="IIFLMARKET" disabled />
                </span>
                <CopyTextButton text="IIFLMARKET" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>API Package:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="Interactive Order API" disabled />
                </span>
                <CopyTextButton text="Interactive Order API" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Company Name: </h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="IIFL1" disabled />
                </span>
                <CopyTextButton text="IIFL1" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Redirect URL: </h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="https://ttblaze.iifl.com/interactive" disabled />
                </span>
                <CopyTextButton text="https://ttblaze.iifl.com/interactive" />
              </div>
            </div>
          </div>
        </div>
      </li>
      <li className="stepper_item" data-stepper="10">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            After successfully create api, you should wait till api activation from iifl team.
          </h2>
          <p>
            Generally, API Activation activity is scheduled daily i.e. @ 9:00 am, 12:30 pm and 5:30 pm. If not
            activated within a day contact IIFL support.
          </p>
        </div>
      </li>
      <li className="stepper_item" data-stepper="12">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Once api activated, Click the back button and fill the API credentials in the required field
          </h2>
          <img src="/landing-page-img/brokers-img/last-step.png" alt="IIFL fill form" />
        </div>
      </li>
    </div>
  </div>
);

export default Iifl;
